export const DropWidgetsHereMessage = () => "Drop Widgets Here";
export const DropModalHereMessage = () => "Drop the Modal here";
export const ANVIL_WIDGET_NAME_TOGGLE_PARENT = () => "Select parent widget";
export const ANVIL_WIDGET_NAME_DEBUG_CLICK = () => "Debug issue";

// Shown in a drop arena when the dragged widget is not allowed in the layout.
export const LAYOUT_DOESNT_SUPPORT_WIDGET_MESSAGE = () =>
  "This Layout doesn't support the widget";

// Command palette (M3.1). MOVE_WIDGET_LABEL is shared between the palette
// command and KeyboardMoveController's listbox aria-label — the keyboardDnD
// cluster may import THIS module because it is a leaf (plain factories, no
// app-graph imports); keep it that way.
export const MOVE_WIDGET_LABEL = () => "Move widget";
export const EXIT_PREVIEW_MODE_LABEL = () => "Exit preview mode";
export const TOGGLE_PREVIEW_MODE_LABEL = () => "Toggle preview mode";
export const DEPLOY_APPLICATION_LABEL = () => "Deploy application";
export const TOGGLE_ANVIL_DEBUG_LOGGING_LABEL = () =>
  "Toggle Anvil debug logging";
export const COMMAND_GROUP_EDITOR = () => "Editor";
export const COMMAND_GROUP_DEVELOPER = () => "Developer";
export const COMMAND_PALETTE_PLACEHOLDER = () => "Type a command…";
